"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShortcuts = exports.ShortcutsProvider = void 0;
var react_1 = __importStar(require("react"));
var keyboard_1 = require("./keyboard");
var shortcuts_json_1 = __importDefault(require("./shortcuts.json"));
var SHORTCUTS = shortcuts_json_1.default.map(function (_a) {
    var shortcuts = _a.shortcuts;
    return shortcuts;
}).flat();
var ShortcutsContext = (0, react_1.createContext)({});
var REPEAT_THROTTLE_MS = 130;
var ZOOM_KEY_ALIASES = {
    '+': ['=', 'Equal', 'NumpadAdd'],
    '-': ['Minus', 'NumpadSubtract'],
    '0': ['Digit0', 'Numpad0'],
};
var isInputFocused = function () {
    var inputElements = ['INPUT', 'TEXTAREA', 'SELECT'];
    var activeElement = document.activeElement;
    return activeElement instanceof HTMLElement &&
        (inputElements.includes(activeElement.tagName) || activeElement.isContentEditable);
};
var ShortcutsProvider = function (_a) {
    var children = _a.children, onShortcut = _a.onShortcut;
    var listeners = (0, react_1.useRef)(new Map());
    var lastRepeatTime = (0, react_1.useRef)(new Map());
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        var _a;
        var ctrlKey = event.ctrlKey, shiftKey = event.shiftKey, altKey = event.altKey, metaKey = event.metaKey, key = event.key, repeat = event.repeat;
        if (event.isComposing)
            return;
        var inputFocused = isInputFocused();
        var shortcutKeys = (0, keyboard_1.getKeyboardShortcutKeys)(event);
        var repeatKey = (0, keyboard_1.getKeyboardShortcutKey)(event);
        var now = Date.now();
        var throttled = repeat && now - ((_a = lastRepeatTime.current.get(repeatKey)) !== null && _a !== void 0 ? _a : 0) < REPEAT_THROTTLE_MS;
        if (repeat && !throttled)
            lastRepeatTime.current.set(repeatKey, now);
        SHORTCUTS.forEach(function (_a) {
            var name = _a.name, combos = _a.combos;
            return combos.forEach(function (keys) {
                var _a;
                var interfaceScale = name === 'interfaceScale';
                if (inputFocused && !interfaceScale)
                    return;
                var primary = keys.includes('Mod');
                var modifiers = ((keys.includes('Ctrl') || (primary && keyboard_1.PRIMARY_MODIFIER === 'Ctrl')) === ctrlKey)
                    && ((primary && keyboard_1.PRIMARY_MODIFIER === 'Meta') === metaKey)
                    && (keys.includes('Shift') === shiftKey || (interfaceScale && (keys.includes('+') || keys.includes('0'))))
                    && !altKey
                    && !event.getModifierState('AltGraph');
                var keyMatched = keys.some(function (shortcutKey) {
                    var _a;
                    return (shortcutKey !== 'Ctrl'
                        && shortcutKey !== 'Shift'
                        && shortcutKey !== 'Mod'
                        && (shortcutKeys.includes(shortcutKey) || (interfaceScale && ((_a = ZOOM_KEY_ALIASES[shortcutKey]) === null || _a === void 0 ? void 0 : _a.some(function (alias) { return shortcutKeys.includes(alias); })))));
                });
                if (modifiers && keyMatched) {
                    // Consume repeats and limit hits too, otherwise the browser also zooms.
                    if (interfaceScale)
                        event.preventDefault();
                    if (throttled)
                        return;
                    var combo_1 = combos.indexOf(keys);
                    (_a = listeners.current.get(name)) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) { return listener(combo_1, key, repeat); });
                    onShortcut(name, combo_1, key);
                }
            });
        });
    }, [onShortcut]);
    var on = (0, react_1.useCallback)(function (name, listener) {
        !listeners.current.has(name) && listeners.current.set(name, new Set());
        listeners.current.get(name).add(listener);
    }, []);
    var off = (0, react_1.useCallback)(function (name, listener) {
        var _a;
        (_a = listeners.current.get(name)) === null || _a === void 0 ? void 0 : _a.delete(listener);
    }, []);
    var value = (0, react_1.useMemo)(function () { return ({ grouped: shortcuts_json_1.default, on: on, off: off }); }, [on, off]);
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', onKeyDown);
        return function () { return document.removeEventListener('keydown', onKeyDown); };
    }, [onKeyDown]);
    return (react_1.default.createElement(ShortcutsContext.Provider, { value: value }, children));
};
exports.ShortcutsProvider = ShortcutsProvider;
var useShortcuts = function () {
    return (0, react_1.useContext)(ShortcutsContext);
};
exports.useShortcuts = useShortcuts;
